const puzzleProgressKey = 'wordsearchweb-progress';
const infoDataKey = 'wordsearchweb-info';
const completedDatesKey = 'wordserchweb-completed';

type InfoData = Record<string, PuzzleInfo>;

export interface PuzzleInfo {
  answersAmount: number;
}

export interface SaveProgressData {
  time: number;
  userAnswers: Record<string, string[]>;
  hintsUsed: number;
}

export function savePuzzleProgress(
  date: string,
  userAnswers: Record<string, string[]>,
  time: number,
  hintsUsed: number
): void {
  try {
    localStorage.setItem(`${puzzleProgressKey}-${date}`, JSON.stringify({
      time,
      userAnswers,
      hintsUsed,
    }));
  } catch (e) {
    console.warn(e);
  }
}

export function getSavedPuzzleProgress(date: string): SaveProgressData {
  try {
    const savedDataRaw = localStorage.getItem(`${puzzleProgressKey}-${date}`);
    if (savedDataRaw) {
      const data = JSON.parse(savedDataRaw) as SaveProgressData;
      data.hintsUsed = data.hintsUsed || 0;
      return data;
    }
  } catch (e) {
    console.warn(e);
  }

  return { time: 0, userAnswers: {}, hintsUsed: 0 };
}

export function saveCompletedDates(dates: string[]): void {
  try {
    localStorage.setItem(completedDatesKey, JSON.stringify(dates));
  } catch (e) {
    console.warn(e);
  }
}

export function getSavedCompletedDates(): string[] {
  try {
    const item = localStorage.getItem(completedDatesKey);
    if (item) return JSON.parse(item);
  } catch (e) {
    console.warn(e);
  }

  return [];
}

function getSavedInfoData(): InfoData {
  try {
    const savedData = localStorage.getItem(infoDataKey);
    if (savedData) return JSON.parse(savedData);
  } catch (e) {
    console.warn(e);
  }

  return {};
}

export function savePuzzleInfo(date: string, answersAmount: number): void {
  try {
    const infoData = getSavedInfoData();
    infoData[date] = { answersAmount };
    localStorage.setItem(infoDataKey, JSON.stringify(infoData));
  } catch (e) {
    console.warn(e);
  }
}

export function getDatesNormalizedProgress(): Record<string, number> {
  const result: Record<string, number> = {};

  const infoData = getSavedInfoData();

  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(puzzleProgressKey))
      .forEach((key) => {
        const date = key.slice(puzzleProgressKey.length + 1);
        if (infoData[date]) {
          const progressData = getSavedPuzzleProgress(date);
          const wordsFound = Object.keys(progressData.userAnswers).length;
          result[date] = wordsFound / infoData[date].answersAmount;
        }
      });
  } catch (e) {
    console.warn(e);
  }

  return result;
}
